// hooks/useFullscreen.js
import { useState, useCallback, useEffect } from 'react'

export function useFullscreen(ref) {
    const [isFullscreen, setIsFullscreen] = useState(false)

    const enter = useCallback(() => {
        const el = ref.current
        if (!el) return
        if (el.requestFullscreen) el.requestFullscreen()
        else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen()
    }, [ref])

    const exit = useCallback(() => {
        if (document.exitFullscreen) document.exitFullscreen()
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen()
    }, [])

    const toggle = useCallback(() => isFullscreen ? exit() : enter(), [isFullscreen, enter, exit])

    useEffect(() => {
        const onChange = () => {
            setIsFullscreen(!!document.fullscreenElement)
        }
        document.addEventListener('fullscreenchange', onChange)
        document.addEventListener('webkitfullscreenchange', onChange)
        return () => {
            document.removeEventListener('fullscreenchange', onChange)
            document.removeEventListener('webkitfullscreenchange', onChange)
        }
    }, [])

    return { isFullscreen, toggle, enter, exit }
}